<div class="orders-header" *ngIf="showHeader || showSearch || showMoveDropdown">
  <!-- Move Dropdown Mode -->
  <div class="move-dropdown-container" *ngIf="showMoveDropdown">
    <label class="move-label">Select the load to move orders to:</label>
    <div class="dropdown-with-button">
      <app-custom-dropdown
        [options]="loadOptions"
        [(ngModel)]="selectedLoadId"
        [height]="'24px'"
        [width]="'100%'"
        [borderColor]="'#E9E9E9'"
        [textColor]="'#868484'"
        (selectionChange)="onLoadChange()">
      </app-custom-dropdown>
      <button 
        class="move-load-btn" 
        type="button"
        [disabled]="!selectedLoadId"
        (click)="onMoveButtonClick()">
        Move
      </button>
    </div>
  </div>

  <!-- Normal Header Mode -->
  <ng-container *ngIf="!showMoveDropdown">
    <div class="header-left" *ngIf="showHeader">
      <div class="empty-title">
        <span class="orders-label">Orders ({{ orderCount }})</span>
        <img class="title-icon" src="assets/icons/job-planning/gift.svg" alt="" aria-hidden="true" />
      </div>
    </div>

    <div class="search-bar" *ngIf="showSearch">
      <input
        type="text"
        class="search-input"
        placeholder="SEARCH BY ORDER REF ID"
        [(ngModel)]="searchText"
        (input)="onSearchChange()"
      />
    </div>

    <button 
      class="add-order-button" 
      *ngIf="showAddButton"
      (click)="onAddButtonClick()"
      aria-label="Add orders">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 5V15M5 10H15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </ng-container>
</div>

